module.exports = __webpack_public_path__ + "img/confirmation.c30a4b89.jpg";